module.exports = __webpack_public_path__ + "img/Unidad10-4.4e949dd2.png";